/**
 * Join Request Helper Utilities
 * Shared utilities for join request functionality
 * @author Muskan Thakur
 */
import { format, isValid, parseISO } from "date-fns";
import { dateFormat, number } from "../config/constants";

/**
 * Formats date and time for join request display
 * Format: "DD MMM, YYYY (HH:MM AM/PM)"
 * @author Muskan Thakur
 */
export const formatJoinRequestDateTime = (dateString) => {
  if (!dateString) return "";

  try {
    const date = typeof dateString === "string" ? parseISO(dateString) : dateString;
    if (!isValid(date)) return "";

    const formatted = format(date, dateFormat.JOIN_REQUEST_DATE_FORMAT);
    return formatted.replace(/\b(am|pm)\b/gi, (match) => match.toUpperCase());
  } catch (error) {
    return "";
  }
};

/**
 * Checks if a notification is a join request notification
 * @author Muskan Thakur
 */
export const isJoinRequestNotification = (notification) => {
  if (!notification) return false;

  const { notificationType, NotificationMessage, EntityType } = notification;

  return (
    notificationType === number.NINE &&
    EntityType === "Project" &&
    NotificationMessage &&
    NotificationMessage.toLowerCase().includes("requested to join")
  );
};

/**
 * Checks if a project/member has a pending join request
 * @author Muskan Thakur
 */
export const hasPendingJoinRequest = (item) => {
  return item?.RoleId === null || item?.RoleId === undefined;
};

/**
 * Calculates total member count from owners and collaborators
 * @author Muskan Thakur
 */
export const calculateMemberCount = (project) => {
  if (!project) return 0;

  const ownersList = project?.owners ? project.owners.split(",").filter((id) => id && id.trim()) : [];
  const collaboratorsList = project?.collaborators ? project.collaborators.split(",").filter((id) => id && id.trim()) : [];

  const allMemberIds = [...new Set([...ownersList, ...collaboratorsList])];
  return allMemberIds.length;
};
